import { render } from "./Premis.vue?vue&type=template&id=6d0bd274"
import script from "./Premis.vue?vue&type=script&lang=js"
export * from "./Premis.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__